import React, { type FC } from 'react';

export const InfoSvg: FC = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.33073 6.66406V11.9974H8.66406L8.66406 6.66406H7.33073Z"
                fill="#161719"
            />
            <path
                d="M6.9974 4.9974C6.9974 4.44511 7.44511 3.9974 7.9974 3.9974C8.54968 3.9974 8.9974 4.44511 8.9974 4.9974C8.9974 5.54968 8.54968 5.9974 7.9974 5.9974C7.44511 5.9974 6.9974 5.54968 6.9974 4.9974Z"
                fill="#161719"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.3307 7.9974C15.3307 12.0475 12.0475 15.3307 7.9974 15.3307C3.94731 15.3307 0.664062 12.0475 0.664062 7.9974C0.664062 3.94731 3.94731 0.664062 7.9974 0.664062C12.0475 0.664062 15.3307 3.94731 15.3307 7.9974ZM13.9974 7.9974C13.9974 11.3111 11.3111 13.9974 7.9974 13.9974C4.68369 13.9974 1.9974 11.3111 1.9974 7.9974C1.9974 4.68369 4.68369 1.9974 7.9974 1.9974C11.3111 1.9974 13.9974 4.68369 13.9974 7.9974Z"
                fill="#161719"
            />
        </svg>
    );
};
